import { carouselData } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1300px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            焦点专题
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-[500px] mx-auto">
            深度策划的影视专题内容，发现更多观影灵感
          </p>
        </div>

        <div className="space-y-5 md:space-y-6">
          {carouselData.map((item) => (
            <div
              key={item.id}
              className="group flex flex-col md:flex-row bg-background-50 rounded-lg overflow-hidden border border-background-200/60 hover:border-accent-200/50 transition-all cursor-pointer"
            >
              <div className="w-full md:w-[360px] lg:w-[420px] flex-shrink-0 relative aspect-[16/9] md:aspect-auto overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    (target.parentElement as HTMLElement).style.display = 'none';
                  }}
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-accent-500 text-background-50 text-[10px] font-semibold rounded whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="flex-1 p-5 md:p-6 flex flex-col justify-center">
                <h3 className="text-base md:text-lg font-heading font-bold text-foreground-900 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                  {item.description}
                </p>
                <div className="mt-4">
                  <span className="inline-flex items-center gap-1 text-sm font-medium text-primary-500 cursor-pointer">
                    浏览专题
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}